<script>
    import modalService from '@/services/core/modal.service';
    import Modal from '@/components/modals/Modal';
    import httpService from '@/services/core/http.service';
    import AdminGrid from '@/components/shared/AdminGrid';
    import { DxColumn } from 'devextreme-vue/data-grid';

    export default {
        props: {
            modalData: Object
        },
        components: {
            Modal,
            AdminGrid,
            DxColumn
        },
        data() {
            return {
                isLoading: 0,
                result: []
            };
        },
        methods: {
            close() {
                modalService.closeModal();
            },
            select(invoiceProfileId) {
                if (this.modalData && this.modalData.onSelect) this.modalData.onSelect(invoiceProfileId);

                this.close();
            },
            frequencyLabel(frequency) {
                const labels = {
                    w: 'Weekly',
                    '2w': 'Every 2 weeks',
                    '4w': 'Every 4 weeks',
                    m: 'Monthly',
                    '2m': 'Every 2 months',
                    '3m': 'Quarterly',
                    '6m': 'Every 6 months',
                    y: 'Yearly',
                    '2y': 'Every 2 years'
                };

                return labels[frequency] || frequency;
            },
            profileStatus(profile) {
                // Disabled, or completed (reached its recurrence limit). A null/0 numberRecurring means it
                // recurs indefinitely, so it never becomes "completed".
                const completed = profile.numberRecurring > 0 && profile.occurrencesToDate >= profile.numberRecurring;

                return profile.disable || completed ? 'Inactive' : 'Active';
            },
            loadInvoiceProfiles() {
                const companyId = this.modalData && this.modalData.companyId;

                if (!companyId) return;

                const url = `companies/${companyId}/freshbooks-invoice-profiles`;

                this.isLoading++;

                httpService
                    .get(url)
                    .then(data => {
                        this.result = (data || []).map(p => ({
                            ...p,
                            frequencyLabel: this.frequencyLabel(p.frecuency),
                            total: p.amount ? `${p.amount.amount} ${p.amount.code}` : '',
                            status: this.profileStatus(p)
                        }));
                    })
                    .finally(() => this.isLoading--);
            }
        },
        mounted() {
            this.loadInvoiceProfiles();
        }
    };
</script>

<template>
    <Modal sizeClass="modal-lg">
        <div class="modal-content">
            <div class="modal-header">
                <h3 class="modal-title">Select Invoice Profile</h3>
            </div>
            <div class="modal-body">
                <div v-if="isLoading > 0">Loading...</div>
                <AdminGrid
                    v-if="isLoading == 0"
                    :data-source="result"
                    :showActions="true"
                    :showFilters="false"
                    :showExport="false"
                    :showToolbar="false"
                    storage-key="invoiceProfilesGrid"
                >
                    <DxColumn data-field="id" />
                    <DxColumn data-field="customerId" caption="Freshbook Id" />
                    <DxColumn data-field="frequencyLabel" caption="Frequency" />
                    <DxColumn data-field="total" caption="Total" />
                    <DxColumn data-field="status" caption="Status" />
                    <DxColumn data-field="nextIssueDate" caption="Next Issue Date" />
                    <template #actions="{ item }">
                        <button type="button" class="btn btn-link py-0 lh-1 text-primary" @click="select(item.data.id)">
                            Set Invoice Profile
                        </button>
                    </template>
                </AdminGrid>
            </div>
            <div class="modal-footer d-flex justify-content-between">
                <button type="button" class="btn" @click="close">Close</button>
            </div>
        </div>
    </Modal>
</template>
